import axiosAuth from '../../../shared/configs/axios-auth'

const getDefaultState = () => {
    return {
        events: [],
        tempParticipants: [],
        event: null,
        eventComments: [],
        newsComments: [],
        eventEntries: [],
        loadingEvents: false,
        loadingEventEntries: false,
        codeValid: null,
        codeUsed: null,
        codeMessage: '',
        activateEvent: null,
        ticketData: null,
        ticketStatus: null,
        registerOk: null,
        activationOk: null,
        emailResended: null,
        updatingEvents: false,
        updating: false,
        eventCopyData: null
    }
}

const state = getDefaultState()

const getters = {
    tempParticipants: state => {
        return state.tempParticipants
    },
    events: state => {
        return state.events
    },
    event: state => {
        return state.event
    },
    eventComments: state => {
        return state.eventComments
    },
    newsComments: state => {
        return state.eventComments
    },
    eventEntries: state => {
        return state.eventEntries
    },
    loadingEvents: state => {
        return state.loadingEvents
    },
    loadingEventEntries: state => {
        return state.loadingEventEntries
    },
    codeValid: state => {
        return state.codeValid
    },
    codeMessage: state => {
        return state.codeMessage
    },
    codeUsed: state => {
        return state.codeUsed
    },
    activateEvent: state => {
        return state.activateEvent
    },
    ticketData: state => {
        return state.ticketData
    },
    ticketStatus: state => {
        return state.ticketStatus
    },
    registerOk: state => {
        return state.registerOk
    },
    activationOk: state => {
        return state.activationOk
    },
    emailResended: state => {
        return state.emailResended
    },
    updatingEvents: state => {
        return state.updatingEvents
    },
    updating: state => {
        return state.updating
    },
    eventCopyData: state => {
        return state.eventCopyData
    },
}

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    tempParticipants: (state, payload) => {
        state.tempParticipants = payload
    },
    events: (state, payload) => {
        state.events = payload
    },
    event: (state, payload) => {
        state.event = payload
    },
    eventComments: (state, payload) => {
        state.eventComments = payload
    },
    newsComments: (state, payload) => {
        state.eventComments = payload
    },
    eventEntries: (state, payload) => {
        state.eventEntries = payload
    },
    loadingEvents: (state, payload) => {
        state.loadingEvents = payload
    },
    loadingEventEntries: (state, payload) => {
        state.loadingEventEntries = payload
    },
    codeValid: (state, payload) => {
        state.codeValid = payload
    },
    codeMessage: (state, payload) => {
        state.codeMessage = payload
    },
    codeUsed: (state, payload) => {
        state.codeUsed = payload
    },
    activateEvent: (state, payload) => {
        state.activateEvent = payload
    },
    ticketData: (state, payload) => {
        state.ticketData = payload
    },
    ticketStatus: (state, payload) => {
        state.ticketStatus = payload
    },
    registerOk: (state, payload) => {
        state.registerOk = payload
    },
    activationOk: (state, payload) => {
        state.activationOk = payload
    },
    emailResended: (state, payload) => {
        state.emailResended = payload
    },
    updatingEvents: (state, payload) => {
        state.updatingEvents = payload
    },
    updating: (state, payload) => {
        state.updating = payload
    },
    setEventCopyData: (state, payload) => {
        state.eventCopyData = payload
    },
    clearEventCopyData: (state) => {
        state.eventCopyData = null
    }
}

const actions = {

    getEventByID: ({ commit, dispatch }, id) => {
        commit('loadingEvents', true)
        axiosAuth.get('/events/byId/' + id, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('loadingEventNews', false)
                    if (!res.data.message) {
                        dispatch('getEventComments', res.data._id)
                        commit('event', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('loadingEvents', false)

                }
            )
    },

    getEventByIdAdmin: ({ commit, state }, id) => {
        commit('updatingEvents', true)
        return axiosAuth.get('/events/byIdAdmin/' + id, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updatingEvents', false)
                    if (!res.data.message && res.data) {
                        // Update events array: replace if exists, otherwise add
                        const eventIndex = state.events.findIndex(e => e._id === res.data._id);
                        if (eventIndex !== -1) {
                            const updatedEvents = [...state.events];
                            updatedEvents[eventIndex] = res.data;
                            commit('events', updatedEvents);
                        } else {
                            commit('events', [...state.events, res.data]);
                        }
                        
                        // Comments werden vom Component's watch geladen
                    }
                    return res.data;
                }
            )
            .catch(
                error => {
                    console.log('getEventByIdAdmin error:', error.response)
                    commit('updatingEvents', false)
                    throw error;
                }
            )
    },

    getEvents: ({ commit }) => {
        commit('updating', true)
        axiosAuth.get('/events', {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updating', false)
                    if (!res.data.message) {
                        // Ensure we have entries arrays for safe client-side CSV exports
                        const normalized = (Array.isArray(res.data) ? res.data : []).map(e => ({
                            ...e,
                            entries: Array.isArray(e.entries) ? e.entries : []
                        }))
                        commit('events', normalized)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)

                }
            )
    },

    getEventComments: ({ commit }, id) => {
        // console.log('eventid:', id)
        commit('updating', true)
        axiosAuth.get('/eventComments/' + id)
            .then(
                res => {
                    commit('updating', false)
                    if (!res.data.message) {
                        commit('eventComments', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)

                }
            )
    },

    getNewsComments: ({ commit }, id) => {
        commit('updating', true)
        axiosAuth.get('/newsComments/' + id)
            .then(
                res => {
                    commit('updating', false)
                    if (!res.data.message) {
                        commit('newsComments', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)

                }
            )
    },

    getEventEntries: ({ commit }) => {
        commit('loadingEventEntries', true)
        axiosAuth.get('/events/entries', {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('loadingEventEntries', false)
                    if (!res.data.message) {
                        commit('eventEntries', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('loadingEventEntries', false)

                }
            )
    },

    getEventEntriesUser: ({ commit }, payload) => {
        commit('loadingEventEntries', true)
        axiosAuth.get('/events/entries/user' + (payload ? '?user=' + payload.user + '&event=' + payload.event : ''), {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('loadingEventEntries', false)
                    if (!res.data.message) {
                        commit('eventEntries', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('loadingEventEntries', false)

                }
            )
    },

    getEventEntriesAdmin: ({ commit }) => {
        commit('updating', true)
        return axiosAuth.get('/events/entries', {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updating', false)
                    if (!res.data.message) {
                        commit('eventEntries', res.data)
                    }
                    return Promise.resolve(res.data)
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                    return Promise.reject(error)
                }
            )
    },

    getEventsAdmin: ({ commit, getters }, options = {}) => {
        commit('updatingEvents', true)
        const params = new URLSearchParams();
        if (options.includeArchived) {
            params.append('includeArchived', 'true');
        }
        if (options.year && options.year !== 'null' && options.year !== 'undefined') {
            params.append('year', options.year);
        }
        
        // Add forManager parameter if provided (for context-specific event loading)
        if (options.forManager) {
            params.append('forManager', options.forManager);
        }

        // Use full endpoint with entries when year filter is set (Dashboard needs entry counts)
        // Use optimized list endpoint otherwise (Events overview)
        const useFullData = options.year || options.fullData;
        const url = useFullData 
            ? `/events/admin/getAll${params.toString() ? '?' + params.toString() : ''}`
            : `/events/admin/list${params.toString() ? '?' + params.toString() : ''}`;
        
        return axiosAuth.get(url, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updatingEvents', false)
                    if (!res.data.message) {
                        commit('events', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingEvents', false)
                }
            )
    },

    checkTicket: ({ commit }, payload) => {
        commit('updating', true)
        let data = null
        axiosAuth.get('/events/checkticket/' + payload, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updating', false)
                    commit('ticketData', res.data.data)
                    commit('ticketStatus', res.data.message)
                    data = res.data.data
                }
            )
            .catch(
                error => {
                    console.log(error)
                    commit('updating', false)
                    commit('ticketData', null)
                    commit('ticketStatus', error.response.data.message)
                }
            )
        return data
    },

    scanTicket: ({ commit }, payload) => {
        commit('updating', true)
        axiosAuth.get('/events/scanticket/' + payload, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updating', false)
                    commit('ticketData', res.data.data)
                    commit('ticketStatus', res.data.message)
                }
            )
            .catch(
                error => {
                    console.log(error)
                    commit('updating', false)
                    commit('ticketData', null)
                    commit('ticketStatus', error.response.data.message)
                }
            )
    },

    registerForEvent: ({ commit }, payload) => {
        commit('updating', true)
        axiosAuth.post('/events/registerApp', payload, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    console.log(res)
                    commit('updating', false)
                    commit('paymentState', 'approved')
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('authError', true)
                    commit('authMessage', error.response.data.message)
                    commit('updating', false)

                }
            )
    },

    resendEmail: ({ commit }, payload) => {
        commit('updating', true)
        commit('emailResended', null)
        return axiosAuth.post('/events/resendemail', payload, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updating', false)
                    // Store the item ID to track which item the email was sent for
                    commit('emailResended', payload._id || payload.id || res.data.message)
                    return Promise.resolve(res)
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('emailResended', null)
                    commit('authError', true)
                    commit('authMessage', error.response ? error.response.data.message : error.message)
                    commit('updating', false)
                    return Promise.reject(error)
                }
            )
    },

    downloadInvoice: ({ commit }, payload) => {
        if (!payload._id) return;
        commit('updating', true)

        axiosAuth.get('/invoices/download/' + payload._id, { responseType: 'blob' })
            .then(
                res => {
                    console.log(res)
                    commit('updating', false)

                    var fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', payload.invoice_nr + '.pdf');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                }
            )
            .catch(
                error => {
                    console.log(error)
                    commit('updating', false)
                }
            )
    },

    activateEntry: ({ commit }, payload) => {
        commit('updating', true)
        axiosAuth.post('/events/activateentry', payload, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updating', false)
                    commit('activationOk', res.data.status)
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('authError', true)
                    commit('authMessage', error.response.data.message)
                    commit('updating', false)

                }
            )
    },

    verifyToken: ({ commit }, payload) => {
        commit('updating', true)
        axiosAuth.get('/events/verifytoken/' + payload, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updating', false)
                    commit('activateEvent', res.data)
                }
            )
            .catch(
                error => {
                    commit('updating', false)
                    commit('authError', true)
                    commit('authMessage', error.response.data.message)
                    console.log(error.response)
                }
            )
    },

    checkCode: ({ commit }, payload) => {
        commit('updating', true)
        axiosAuth.get('/events/checkcode/' + payload.eventId + '/' + payload.eventCode, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('codeValid', res.data.valid)
                    commit('codeUsed', res.data.used)
                    commit('codeMessage', res.data.message)
                    commit('updating', false)
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('codeValid', false)
                    commit('codeUsed', null)
                    commit('codeMessage', 'Abfragefehler!')
                    commit('updating', false)

                }
            )
    },

    updateEvent: ({ commit, }, payload) => {
        commit('updating', true)
        // approved darf niemals per PATCH gesendet werden
        const { approved, ...safePayload } = payload
        return axiosAuth.patch('/events/' + safePayload._id, safePayload)
            .then(
                () => {
                    commit('updating', false)
                }
            )
            .catch(
                error => {
                    commit('updating', false)
                    // 409 Conflict: Merge-Konflikt erkannt
                    if (error.response && error.response.status === 409 && error.response.data && error.response.data.conflict) {
                        const conflictError = new Error('CONFLICT')
                        conflictError.conflictData = error.response.data
                        throw conflictError
                    }
                    console.log(error.response)
                    throw error
                }
            )
    },

    updateEventEntry: ({ commit, dispatch }, payload) => {
        let data = JSON.parse(JSON.stringify(payload))
        data.edit = false
        commit('updating', true)
        return axiosAuth.patch('/events/entry/' + data._id, data)
            .then(
                async () => {
                    // Wait for getEventEntriesAdmin to complete before resolving
                    await dispatch('getEventEntriesAdmin')
                    commit('updating', false)
                    return Promise.resolve()
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                    return Promise.reject(error)
                }
            )
    },

    downloadSponsorCSV: ({ commit }, payload) => {
        commit('updating', true)
        axiosAuth.get('/events/csv/' + payload.event._id + '/' + payload.sponsor._id)
            .then(
                res => {
                    commit('updating', false)
                    var fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', payload.sponsor.title + '.csv');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            )
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}